<div class="layout-topbar">
  <a class="layout-topbar-logo flex gap-2">
    <div class="flex items-center gap-2">
      <img src="/assets/logos/logo.svg" alt="logo" />
      <span class="text-[13px] mt-auto">{{ version }}</span>
    </div>
  </a>

  <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
    <i class="pi pi-bars"></i>
  </button>

  <button
    #topbarmenubutton
    class="p-link layout-topbar-menu-button layout-topbar-button"
    (click)="layoutService.showProfileSidebar()"
  >
    <i class="pi pi-ellipsis-v"></i>
  </button>

  <div
    #topbarmenu
    class="layout-topbar-menu"
    [ngClass]="{ 'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible }"
  >
    @if (
      !router.url.includes('editions') &&
      !router.url.includes('categories') &&
      !router.url.includes('galleries') &&
      !router.url.includes('users') &&
      !router.url.includes('forms') &&
      !router.url.includes('guides/list') &&
      !router.url.includes('guides/categories') &&
      !router.url.includes('sended-emails') &&
      !router.url.includes('community-forum') &&
      !router.url.includes('reservation-items/hotels') &&
      !router.url.includes('reservation-items/ferrys')
    ) {
      <p-dropdown
        appendTo="body"
        (onChange)="setEdition($event)"
        [options]="(activeEditions$ | async) ?? []"
        optionLabel="name"
        optionValue="id"
        styleClass="w-full"
        [(ngModel)]="currentEditionId"
      >
      </p-dropdown>
    }
    <button class="p-link layout-topbar-button" (click)="logout()">
      <i class="pi pi-fw pi-sign-out"></i>
      <span>Cerrar Sesión</span>
    </button>
  </div>
</div>
